
<template>
    <v-carousel
      cycle
      interval="8000"
      height="600"
      hide-delimiter-background
      show-arrows-on-hover
  >
    <v-carousel-item v-for="(item, index) in itemsCarousel" :key="index">
      <v-responsive>
        <v-img
            gradient="to right, rgba(0,0,0,.05), rgba(0,0,0,0.05)"
            :src="lookupImageUrl(item)"
            min-height="600px"
        />
      </v-responsive>
    </v-carousel-item>
  </v-carousel>

</template>

<script>
import  FDinCarouselService  from '@/services/apiservices/f-din-carousel-service'
import FileService from "@/services/apiservices/file-service";
export default {
  name: 'PotensiMainCarousel',
  data() {
    return {
      itemsCarousel: [],
    }
  },
  methods: {
    fetchFDinCarousel() {
      FDinCarouselService.getAllFDinCarouselByTypePublic(1)
        .then(response => {
          this.itemsCarousel = response.data.filter((x) => x.statusActive === true)
        })
        .catch(e => {
          console.log(e)
        })
    },

    lookupImageUrl(item) {
      if (item.avatarImage !== undefined && item.avatarImage !== "") {
        console.log("carousel Main")
        return FileService.image_url_high(item.avatarImage);
      } else {
        return require("@/assets/images/no_image_available.jpeg");
      }
    },
    lookupImageUrlLazy(item) {
      if (item.avatarImage !== undefined && item.avatarImage !== "") {
        return FileService.image_url_verylow(item.avatarImage);
      } else {
        return require("@/assets/images/no_image_available.jpeg");
      }
    },

  },
  created() {
    this.fetchFDinCarousel()
  }
}

</script>

<style scoped>

</style>